<template>
    <div>
        <!-- Input Form -->
        <form v-if="!calculated" @submit.prevent="submit">
            <div class="form-group">
                <label>Current Monthly Electricity Bill (in USD):</label>
                <input
                    type="text"
                    v-model="form.currentBill"
                    :class="['form-control', form.errors.currentBill ? 'is-invalid' : '']"
                    placeholder="Enter your average monthly electricity bill"
                />
                <div v-text="form.errors.currentBill" class="invalid-feedback"></div>
            </div>

            <div class="form-group">
                <label>Solar System Efficiency (%):</label>
                <input
                    type="text"
                    v-model="form.efficiencyRate"
                    :class="['form-control', form.errors.efficiencyRate ? 'is-invalid' : '']"
                    placeholder="Enter efficiency rate as a percentage (e.g., 80)"
                />
                <div v-text="form.errors.efficiencyRate" class="invalid-feedback"></div>
            </div>

            <div class="form-group">
                <button
                    :class="['btn btn-primary btn-block', form.loading ? 'btn-loading' : '']"
                >
                    Estimate Savings
                </button>
            </div>
        </form>

        <!-- Results Section -->
        <div v-if="calculated" class="result-container slide-in mt-4">
            <div class="alert alert-info text-center">
                <p>
                    Based on your inputs, you can save approximately
                    <b>{{ result.annualSavings }}</b> USD annually by switching to solar power.
                </p>
            </div>
            <button @click="reset" class="btn btn-secondary btn-block">
                Perform Another Calculation
            </button>
        </div>
    </div>
</template>

<script>
import BillShell from "../../bill-shell.vue";

export default {
    components: { BillShell },
    data() {
        return {
            form: {
                currentBill: '',
                efficiencyRate: '',
                errors: {}, // Object to store validation errors
                loading: false,
            },
            calculated: false,
            result: { annualSavings: 0 },
        };
    },
    methods: {
        validateForm() {
            this.form.errors = {};

            // Validate current bill
            if (!this.form.currentBill || isNaN(this.form.currentBill) || parseFloat(this.form.currentBill) <= 0) {
                this.form.errors.currentBill = 'Please enter a valid monthly electricity bill.';
            }

            // Validate efficiency rate
            if (!this.form.efficiencyRate || isNaN(this.form.efficiencyRate) || parseFloat(this.form.efficiencyRate) <= 0 || parseFloat(this.form.efficiencyRate) > 100) {
                this.form.errors.efficiencyRate = 'Please enter a valid efficiency rate (1-100).';
            }

            return Object.keys(this.form.errors).length === 0;
        },

        submit() {
            if (!this.validateForm()) return;

            this.form.loading = true;
            setTimeout(() => {
                const currentBill = parseFloat(this.form.currentBill);
                const efficiencyRate = parseFloat(this.form.efficiencyRate) / 100;

                // Calculate annual savings
                const annualSavings = (currentBill * 12 * efficiencyRate).toFixed(2);

                this.result.annualSavings = annualSavings;
                this.calculated = true; // Toggle to show results
                this.form.loading = false;
            }, 500); // Simulate processing delay
        },

        reset() {
            this.form.currentBill = '';
            this.form.efficiencyRate = '';
            this.calculated = false; // Reset to show form again
        },
    },
};
</script>

<style>
.slide-in {
    animation: slideIn 0.5s ease-in-out;
}

@keyframes slideIn {
    from {
        transform: translateX(-100%);
        opacity: 0;
    }
    to {
        transform: translateX(0);
        opacity: 1;
    }
}

.is-invalid {
    border-color: #dc3545;
}

.invalid-feedback {
    color: #dc3545;
    font-size: 0.875rem;
}

.btn-loading {
    cursor: not-allowed;
    opacity: 0.65;
}
</style>
